var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSalesDevelopment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 94,
    height: 94,
    viewBox: "0 0 94 94",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.974 92.0417H92.0573",
    stroke: "#07143F",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.625 74.4166C17.625 73.8972 17.4187 73.3991 17.0514 73.0318C16.6842 72.6646 16.186 72.4583 15.6667 72.4583H7.83333C7.31395 72.4583 6.81584 72.6646 6.44858 73.0318C6.08132 73.3991 5.875 73.8972 5.875 74.4166V92.0416H17.625V74.4166Z",
    stroke: "#07143F",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M41.125 54.8333C41.125 54.314 40.9187 53.8158 40.5514 53.4486C40.1842 53.0813 39.686 52.875 39.1667 52.875H31.3333C30.814 52.875 30.3158 53.0813 29.9486 53.4486C29.5813 53.8158 29.375 54.314 29.375 54.8333V92.0417H41.125V54.8333Z",
    stroke: "#07143F",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M64.625 62.6666C64.625 62.1472 64.4187 61.6491 64.0514 61.2818C63.6842 60.9146 63.186 60.7083 62.6667 60.7083H54.8333C54.314 60.7083 53.8158 60.9146 53.4486 61.2818C53.0813 61.6491 52.875 62.1472 52.875 62.6666V92.0416H64.625V62.6666Z",
    stroke: "#07143F",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M88.125 35.2501C88.125 34.7307 87.9187 34.2326 87.5514 33.8653C87.1842 33.4981 86.686 33.2917 86.1667 33.2917H78.3333C77.814 33.2917 77.3158 33.4981 76.9486 33.8653C76.5813 34.2326 76.375 34.7307 76.375 35.2501V92.0417H88.125V35.2501Z",
    stroke: "#07143F",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M11.7657 50.9167C15.0103 50.9167 17.6407 48.2864 17.6407 45.0417C17.6407 41.7971 15.0103 39.1667 11.7657 39.1667C8.52098 39.1667 5.89066 41.7971 5.89066 45.0417C5.89066 48.2864 8.52098 50.9167 11.7657 50.9167Z",
    stroke: "#07143F",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M35.2657 31.3333C38.5103 31.3333 41.1407 28.7029 41.1407 25.4583C41.1407 22.2136 38.5103 19.5833 35.2657 19.5833C32.021 19.5833 29.3907 22.2136 29.3907 25.4583C29.3907 28.7029 32.021 31.3333 35.2657 31.3333Z",
    stroke: "#07143F",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M58.7657 39.1667C62.0103 39.1667 64.6407 36.5364 64.6407 33.2917C64.6407 30.0471 62.0103 27.4167 58.7657 27.4167C55.521 27.4167 52.8907 30.0471 52.8907 33.2917C52.8907 36.5364 55.521 39.1667 58.7657 39.1667Z",
    stroke: "#07143F",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M82.2657 13.7083C85.5103 13.7083 88.1407 11.0779 88.1407 7.83325C88.1407 4.58858 85.5103 1.95825 82.2657 1.95825C79.021 1.95825 76.3907 4.58858 76.3907 7.83325C76.3907 11.0779 79.021 13.7083 82.2657 13.7083Z",
    stroke: "#07143F",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M16.7046 40.9291L30.7537 29.2183",
    stroke: "#07143F",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M40.8391 27.3149L53.1922 31.4314",
    stroke: "#07143F",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M77.5657 11.3584L62.8429 28.533",
    stroke: "#07143F",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSalesDevelopment);
export default __webpack_public_path__ + "static/media/sales-development.421464a705b27a5ecd22fa48559da97b.svg";
export { ForwardRef as ReactComponent };